export const EXCLUDED_STATE_KEYS = [
  'cssVars',
  'componentsConfig',
  'inputs',
  'errorText',
  'errorType',
  'clientScripts',
];
